













import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import Button from '@/apps/open/components/Button'
import { ACCESS_KNOW_URL } from '@/apps/open/constants'
import EditPauthCallbackDialogBody from '@/apps/open/components/DialogBodys/app/EditPauthCallback.vue'
import { onRequestError } from '@/apps/open/utils'
import { IAppInfo } from '@/apps/open/store/modules/app/types'

@Component({
  components: {
    Button
  },
  data: () => ({
    CALLBACK_URL: ACCESS_KNOW_URL
  })
})
export default class PersonAuthCallbackSetting extends Vue {
  title = '授权回调地址'

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get appId () {
    return this.$route.params.id
  }

  get callbackList () {
    return this.app.callback_url ? this.app.callback_url.split('|') : ['']
  }

  get app (): IAppInfo {
    return this.$store.getters['App/appInfo']
  }

  get isSandbox () {
    return this.app.is_sandbox
  }

  viewCallbackList () {
    this.$dialog.show({
      title: this.title,
      body: this.callbackList.join('<br>'),
      buttons: [
        { text: '取消' },
        { text: '修改', type: 'primary', fn: this.setCallbackList }
      ]
    })
  }

  setCallbackList () {
    this.$dialog.show({
      title: `${this.title}配置`,
      className: 'pauth-calllback-dialog',
      body: EditPauthCallbackDialogBody,
      bodyProps: {
        callbackList: this.callbackList,
        isSandbox: this.isSandbox,
        submit: this.submitCallbackList
      },
      buttons: [
        { text: '取消' },
        { text: '确定', type: 'primary', event: 'onOk' }
      ]
    })
  }

  async submitCallbackList (callbackList: string[]) {
    try {
      await this.$store.dispatch('App/UPDATE_APP_INFO', { app_id: this.appId, callback_url: callbackList.join('|') })
      this.$message.success('授权回调地址保存成功')
    } catch (error) {
      onRequestError(error)
    }
    this.$dialog.close()
  }
}
